export function priceformatter (price: number) {
   return `${new Intl.NumberFormat('ru-RU').format(price)} UZS`
}